'use strict';

// eslint-disable-next-line
const NotificationMessage = require('telco/components/toastNotification');

var mdulistGlbl = [];
const cache = {
    $submit: $('#adresscheck-submit'),
    $o2check: $('#o2check'),
    $o2UnitsOptions: $('#o2UnitsOptions'),
    $o2UnitNumber: $('#o2UnitNumber'),
    $unitNumber: $('#unitNumber'),
    $form: $('#outage-checker-form'),
    $o2Input: $('#o2check'),
    $insertO2Script: $('#o2AppendScript'),
    $jsActiveOutageMessageBanner: $('.js-mp-nonLogIn-activeOutageMessage-banner'),
    $jsNonActiveOutageMessageBanner: $('.js-mp-nonLogIn-nonActiveOutageMessage-banner'),
    $addressNotFound: $('#addressNotFound'),
    $latitude: $('#latitude'),
    $longitude: $('#longitude'),
    $serviceAddress: $('#serviceAddress'),
    $streetNum: $('#streetNum'),
    $street: $('#street'),
    $city: $('#city'),
    $stateCode: $('#stateCode'),
    $countryCode: $('#countryCode'),
    $zipcode: $('#zipcode'),
    unit: null,
    $marker: null,
    map: null,
    $crossIcon: $('.icon__cross-circle-map-locator').html(),
    $checkIcon: $('.icon__toast-success').html()
};
/**
 * Update google maps
 * @param {Object} data Address data
 * @param {boolean} outage Outage Status
 */
function updateMap(data, outage) {
    const template = cache.$crossIcon;
    const templateNoOutage = cache.$checkIcon;

    var svg = template.replace('{{ color }}', '#888');
    var blob = new Blob([svg], { type: 'image/svg+xml' });
    var blobUrl = URL.createObjectURL(blob);

    var svgNoOutage = templateNoOutage.replace('{{ color }}', '#888');
    var blobNoOutage = new Blob([svgNoOutage], { type: 'image/svg+xml' });
    var blobUrlNoOutage = URL.createObjectURL(blobNoOutage);

    var image = {
        url: blobUrl,
        anchor: new window.google.maps.Point(13, 13)
    };

    var imageNoOutage = {
        url: blobUrlNoOutage,
        scaledSize: new window.google.maps.Size(32, 32),
        anchor: new window.google.maps.Point(13, 13)
    };

    let defaultLat = 38;
    let defaultLng = -97;
    let location = {
        lat: Number(data.lat) || defaultLat,
        lng: Number(data.long) || defaultLng
    };
    let initialZoom = data.lat && data.long ? 18 : 4;
    cache.map = new window.google.maps.Map(document.getElementById('map'), {
        center: location,
        zoom: initialZoom,
        clickableIcons: false,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false
    });
    if (data.lat && data.long) {
        if (outage === false) {
            cache.$marker = new window.google.maps.Marker({
                position: location,
                map: cache.map,
                icon: imageNoOutage,
                draggable: false
            });
        } else {
            cache.$marker = new window.google.maps.Marker({
                position: location,
                map: cache.map,
                icon: image,
                draggable: false
            });
        }
    }
}


/**
 * Populates the hidden inputs with the given address components for O2 type ahead
 * @param {*} addressData object with adress components
 */
function fillAddressO2Inputs(addressData) {
    cache.$serviceAddress.val(addressData.address);
    cache.$latitude.val(addressData.lat);
    cache.$longitude.val(addressData.long);
    cache.$streetNum.val(addressData.streetNum);
    cache.$street.val(addressData.street);
    cache.$city.val(addressData.city);
    cache.$stateCode.val(addressData.stateCode);
    cache.$countryCode.val(addressData.countryCode);
    cache.$zipcode.val(addressData.zipcode);
}
/**
 * renderUpddatedOutageMap ajax request
 * @param {string} ev url for ajax request
 */
function renderUpddatedOutageMap(ev) {
    ev.preventDefault();
    cache.$jsNonActiveOutageMessageBanner.hide();
    cache.$jsActiveOutageMessageBanner.hide();
    $('.js-impacted-data').hide();
    if (!cache.$latitude.val() || !cache.$longitude.val()) {
        var address = cache.$o2check.val();
        updateMap({});
        new NotificationMessage((cache.$addressNotFound.val().replace('SERVICE_ADDRESS', address)), {
            duration: 3000,
            type: 'error'
        }).show();
        return;
    }
    $.spinner().start();
    const payload = {
        latitude: cache.$latitude.val(),
        longitude: cache.$longitude.val(),
        unit: cache.unit === 'No-Unit' ? '' : cache.unit,
        serviceAddress: cache.$serviceAddress.val(),
        streetNum: cache.$streetNum.val(),
        street: cache.$street.val(),
        city: cache.$city.val(),
        stateCode: cache.$stateCode.val(),
        countryCode: cache.$countryCode.val(),
        zipcode: cache.$zipcode.val()
    };
    const url = cache.$form.attr('action');
    $.ajax({
        url: url,
        type: 'post',
        data: payload,
        success: function (data) {
            var gtmPushObj = {
                step: 'outage check'
            };
            if (data.outageCheckerResponse && data.outageCheckerResponse.NumberOfSubscribers) {
                $('.js-impacted-count').html(data.outageCheckerResponse.NumberOfSubscribers);
                $('.js-impacted-data').css('display', 'flex');
            }
            if (data.outageCheckerResponse.OutageStatus === 'Active Outage') {
                updateMap(data.addressObj, true);
                cache.$NumberOfSubscribers = data.NumberOfSubscribers;
                cache.$jsNonActiveOutageMessageBanner.hide();
                cache.$jsActiveOutageMessageBanner.show();
                gtmPushObj.messageDisplayed = cache.$jsActiveOutageMessageBanner.find('.message-title').text();
            } else {
                updateMap(data.addressObj, false);
                cache.$jsActiveOutageMessageBanner.hide();
                cache.$jsNonActiveOutageMessageBanner.show();
                gtmPushObj.messageDisplayed = cache.$jsNonActiveOutageMessageBanner.find('.message-title').text();
            }
            $('body').trigger('gtm:mp:outageToolPage', gtmPushObj);
            $.spinner().stop();
        },
        error: function (err) {
            $.spinner().stop();
            updateMap({});
            new NotificationMessage((err.responseJSON.message), {
                duration: 3000,
                type: 'error'
            }).show();
        }
    });
}

/**
 * o2VariantRequest
 */
function o2VariantRequest() {
    var endpoint = cache.$form.data('addressesbyvariantaddress-url');
    var address = $('#o2check').val();
    var o2Script = endpoint + '?addressesStartsWith=' + encodeURIComponent(address) + '&maxResults=1&callback=o2VariantResponse';
    if (cache.$insertO2Script.children().length > 0) {
        cache.$insertO2Script.empty();
    }
    cache.$o2UnitsOptions.selectize()[0].selectize.destroy();
    cache.$insertO2Script.append($('<script></script>').attr('src', o2Script));
}

/**
 * updateMDUUnits
 * @param {Object} element the HTML element for the address suggestion
 */
function updateMDUUnits(element) {
    var isAddressMDU = $(element).find('input').data('mdu');
    var addressInfo = $(element).find('input').data('addressinfo');
    cache.$submit.attr('disabled', false);
    if (isAddressMDU === 'TRUE') {
        $('#o2-unit-select-container').show();
        $('#o2-unit-input-container').hide('slow');
        cache.$submit.attr('disabled', true);
        var addressId = $(element).find('input').data('addressid');
        var endpoint = cache.$form.data('getmduunits-url');
        var mduScript = endpoint + '?addressId=' + addressId + '&callback=mduResponse';
        if (cache.$insertO2Script.children().length > 0) {
            cache.$insertO2Script.empty();
        }
        cache.$insertO2Script.append($('<script></script>').attr('src', mduScript));
    } else {
        cache.$submit.attr('disabled', false);
        $('#o2-unit-select-container').hide('slow');
        $('#o2-unit-input-container').show();
    }
    fillAddressO2Inputs(addressInfo);
}

/**
 * Service call to Geo Code
 * @param {Object} inp updates - fields with updates for account
 * @param {Array} arr response from the service call
 * @param {string} addressCount response from the api call
 */
function autocomplete(inp, arr, addressCount) {
    /**
    *JSDoc Comment
    *@param {Object} x isml field
    *
    */
    function removeActive(x) {
        /* a function to remove the "active" class from all autocomplete items:*/
        for (var i = 0; i < x.length; i++) {
            x[i].classList.remove('autocomplete-active');
        }
    }
    /**
    *JSDoc Comment
    *@param {Object} x object
    *@returns {Object} object
    */
    function addActive(x) {
        /* a function to classify an item as "active":*/
        if (!x) return false;
        /* start by removing the "active" class on all items:*/
        removeActive(x);
        if (currentFocus >= x.length) currentFocus = 0; // eslint-disable-line
        if (currentFocus < 0) currentFocus = (x.length - 1); // eslint-disable-line
        /* add class "autocomplete-active":*/
        x[currentFocus].classList.add("autocomplete-active"); // eslint-disable-line
        return; // eslint-disable-line
    }
    /**
    *JSDoc Comment
    *@param {Object} elmnt updates - fields with updates for account
    */
    function closeAllLists(elmnt) {
        /* close all autocomplete lists in the document,
        except the one passed as an argument:*/
        var x = document.getElementsByClassName('autocomplete-items');
        for (var i = 0; i < x.length; i++) {
            if (elmnt !== x[i] && elmnt !== inp) {
                x[i].parentNode.removeChild(x[i]);
            }
        }
    }
    var currentFocus; // eslint-disable-line
    /**
     * JSDoc Comment
     * @param {Object} inputbox O2check input text field
     * @returns {Object} object
     */
    function loadValuesToAutoCompleteLists(inputbox) {
        /* Function to populate the Ajax Response to autocomplete dropdown */
        cache.$latitude.val(null);
        cache.$longitude.val(null);
        cache.$streetNum.val(null);
        cache.$street.val(null);
        cache.$city.val(null);
        cache.$stateCode.val(null);
        cache.$countryCode.val(null);
        cache.$zipcode.val(null);
        var a;
        var b;
        var i;
        var val = document.getElementById('o2check').value;// eslint-disable-line
        /* close any already open lists of autocompleted values*/
        closeAllLists();
        if (!val) { return false; }
        currentFocus = -1; // eslint-disable-line
        /* create a DIV element that will contain the items (values):*/
        a = document.createElement('div');
        a.setAttribute('id', document.getElementById('o2check').id + 'autocomplete-list');
        a.setAttribute('class', 'autocomplete-items');
        /* append the DIV element as a child of the autocomplete container:*/
        document.getElementById('o2check').parentNode.appendChild(a);
        /* for each item in the array...*/
        for (i = 0; i < arr.length; i++) {
            /* check if the item starts with the same letters as the text field value:*/
            /* create a DIV element for each matching element:*/
            b = document.createElement('div');
            /* make the matching letters bold:*/
            b.innerHTML = '<span class="map-icon"></span> <strong>' + arr[i].address.substr(0, val.length) + '</strong>'; // eslint-disable-line
            b.innerHTML += arr[i].address.substr(val.length);
            b.classList.add('addressSuggestion');
            /* insert a input field that will hold the current array item's value:*/
            b.innerHTML += "<input type='hidden' value='" + arr[i].address + "' data-mdu = '" + arr[i].mdu + "' data-addressId = '" + arr[i].addressId + "' data-addressInfo = '" + JSON.stringify(arr[i]) + "'>"; // eslint-disable-line
            /* execute a function when someone clicks on the item value (DIV element):*/
            /* Changed the event to mousedown from click, since click is not firing after bringing in the Focus out event:*/
            b.addEventListener('mousedown', function () {
                /* insert the value for the autocomplete text field:*/
                cache.unit = '';
                inputbox.value = this.getElementsByTagName('input')[0].value;
                var addressInfo = JSON.parse(this.getElementsByTagName('input')[0].getAttribute('data-addressInfo'));
                updateMDUUnits(this);
                fillAddressO2Inputs(addressInfo);
                /* close the list of autocompleted values,
                (or any other open lists of autocompleted values:*/
                closeAllLists();
            });
            a.appendChild(b);
        }
        return; // eslint-disable-line
    }
    /**
     *execute a function presses a key on the keyboard
    */
    inp.addEventListener('keydown', function (e) {
        var x = document.getElementById(this.id + 'autocomplete-list');
        if (x) x = x.getElementsByTagName('div');
        if (e.keyCode === 40) {
            /* If the arrow DOWN key is pressed,
            increase the currentFocus variable:*/
            currentFocus++; // eslint-disable-line
            /* and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode === 38) { // up
            /* If the arrow UP key is pressed, decrease the currentFocus variable:*/
            currentFocus--; // eslint-disable-line
            /* and and make the current item more visible:*/
            addActive(x);
        } else if (e.keyCode === 13) {
            /* If the ENTER key is pressed, prevent the form from being submitted,*/
            e.preventDefault();
            if (currentFocus > -1) { // eslint-disable-line
                /* and simulate a click on the "active" item:*/
                if (x) x[currentFocus].click(); // eslint-disable-line
            }
        }
    });

    /* execute a function when someone moves out of Service Address Text Field:*/
    inp.addEventListener('focusout', function () {
        if (Number(addressCount) === 1) {
            o2VariantRequest();
        } else if (cache.$o2check.val().length === 0) {
            cache.$submit.attr('disabled', true);
            $(cache.$o2UnitsOptions).empty();
        } else if ($(this).val().length > 3) {
            cache.$submit.attr('disabled', false);
        }
    });

    /* execute a function when someone clicks in the document:*/
    document.addEventListener('click', function (e) {
        closeAllLists(e.target);
    });
    /* the autocomplete function takes two arguments,
    the text field element and an array of possible autocompleted values:*/
    // var currentFocus; // eslint-disable-line
    /* execute a function when someone writes in the text field:*/
    inp.addEventListener('input', function () { // eslint-disable-line
        loadValuesToAutoCompleteLists(inp);
    });
    loadValuesToAutoCompleteLists(inp);
}
/**
 * o2Request
 */
function o2Request() {
    var endpoint = cache.$form.data('typeahead-url');
    var address = $('#o2check').val();
    var o2Script = endpoint + '?addressesStartsWith=' + encodeURIComponent(address) + '&maxResults=10&callback=o2Response';
    if (cache.$insertO2Script.children().length > 0) {
        cache.$insertO2Script.empty();
    }
    cache.$insertO2Script.append($('<script></script>').attr('src', o2Script));
}
/**
 * initO2Request
 */
function initO2Request() {
    var keyNum;
    cache.$o2Input.on('input', function () {
        keyNum = $(this).val().length;
        $('#addressKey').val('');
        // requestMDU(238743625);
        if (keyNum > 2) {
            o2Request();
        }
    });
}

$(document).on('o2Event', function (e) {
    const { detail } = e;
    var addresses = detail.response.lstAddresses;
    var addressCount = detail.response.countOfAddress;
    var list = [];
    var streetName = '';
    list = addresses.map(function (address) {
        if (!address.street_suffix || address.street_suffix === 'undefined' || address.street_suffix === 'None') {
            streetName = ((!address.pre_directional_code || address.pre_directional_code === 'undefined' || address.pre_directional_code === 'None' ? '' : address.pre_directional_code).trim() + ' ' + (address.street_name).trim() + ' ' + (!address.post_directional_code || address.post_directional_code === 'undefined' || address.post_directional_code === 'None' ? '' : address.post_directional_code).trim()).trim();
        } else {
            streetName = ((!address.pre_directional_code || address.pre_directional_code === 'undefined' || address.pre_directional_code === 'None' ? '' : address.pre_directional_code).trim() + ' ' + (address.street_name).trim() + ' ' + (address.street_suffix).trim() + ' ' + (!address.post_directional_code || address.post_directional_code === 'undefined' || address.post_directional_code === 'None' ? '' : address.post_directional_code).trim()).trim();
        }
        return {
            address: address.full_address_txt,
            mdu: address.mdu_ind,
            addressId: address.address_id,
            addressKey: address.address_key,
            lat: address.latitude,
            long: address.longitude,
            streetNum: address.house_number,
            street: streetName,
            city: address.city,
            stateCode: address.state,
            stateCodeLong: address.state,
            zipcode: address.postal_code,
            countryCode: 'USA',
            afstreetname: address.street_name,
            afstreetsuffix: address.street_suffix,
            predirection: !address.pre_directional_code || address.pre_directional_code === 'undefined' || address.pre_directional_code === 'None' ? '' : address.pre_directional_code,
            postdirection: !address.post_directional_code || address.post_directional_code === 'undefined' || address.post_directional_code === 'None' ? '' : address.post_directional_code,
            workType: address.work_type,
            geo_type: address.geo_addr_typ,
            propertyId: address.property_Id // TO-DO: PROVIDER ID NEEDS TO BE ADDED ONCE RETURNED IN O2 CACHE
        };
    });
    autocomplete(document.getElementById('o2check'), list, addressCount);
});

$(document).on('o2EventVariant', function (e) {
    const { detail } = e;
    var addresses = detail.response.lstAddresses;
    var streetName = '';
    var x = document.getElementsByClassName('autocomplete-items');
    for (var i = 0; i < x.length; i++) {
        x[i].parentNode.removeChild(x[i]);
    }
    if (addresses[0]) {
        if (!addresses[0].street_suffix || addresses[0].street_suffix === 'undefined' || addresses[0].street_suffix === 'None') {
            streetName = ((!addresses[0].pre_directional_code || addresses[0].pre_directional_code === 'undefined' || addresses[0].pre_directional_code === 'None' ? '' : addresses[0].pre_directional_code).trim() + ' ' + (addresses[0].street_name).trim() + ' ' + (!addresses[0].post_directional_code || addresses[0].post_directional_code === 'undefined' || addresses[0].post_directional_code === 'None' ? '' : addresses[0].post_directional_code).trim()).trim();
        } else {
            streetName = ((!addresses[0].pre_directional_code || addresses[0].pre_directional_code === 'undefined' || addresses[0].pre_directional_code === 'None' ? '' : addresses[0].pre_directional_code).trim() + ' ' + (addresses[0].street_name).trim() + ' ' + (addresses[0].street_suffix).trim() + ' ' + (!addresses[0].post_directional_code || addresses[0].post_directional_code === 'undefined' || addresses[0].post_directional_code === 'None' ? '' : addresses[0].post_directional_code).trim()).trim();
        }
        var isAddressMDU = addresses[0].mdu_ind;
        cache.$latitude.val(addresses[0].latitude);
        cache.$longitude.val(addresses[0].longitude);
        cache.$serviceAddress.val(addresses[0].full_address_txt);
        cache.$streetNum.val(addresses[0].house_number);
        cache.$street.val(streetName);
        cache.$city.val(addresses[0].city);
        cache.$stateCode.val(addresses[0].state);
        cache.$countryCode.val('USA');
        cache.$zipcode.val(addresses[0].postal_code);
        $('#stateCodeLong').val(addresses[0].state);
        $('#mdu').val(isAddressMDU);
        $('#addressId').val(addresses[0].address_key);
        $('#addressKey').val(addresses[0].address_key);
        $('#baseAddr').val(addresses[0].address_key);
        $('#predirection').val(!addresses[0].pre_directional_code || addresses[0].pre_directional_code === 'undefined' || addresses[0].pre_directional_code === 'None' ? '' : addresses[0].pre_directional_code);
        $('#postdirection').val(addresses[0].post_directional_code || addresses[0].post_directional_code === 'undefined' || addresses[0].post_directional_code === 'None' ? '' : addresses[0].post_directional_code);
        $('#afstreetname').val(addresses[0].street_name);
        $('#afstreetsuffix').val(addresses[0].street_suffix);
        $('#o2check').val(addresses[0].full_address_txt);
        $('#workType').val(addresses[0].work_type);
        $('#propertyId').val(addresses[0].property_Id);  // TO-DO: PROVIDER ID NEEDS TO BE ADDED ONCE RETURNED IN O2 CACHE
        $('#geo_type').val(addresses[0].geo_addr_typ);
        // TO-DO: PROVIDER ID NEEDS TO BE ADDED ONCE RETURNED IN O2 CACHE
        if (isAddressMDU === 'TRUE') {
            $('#o2-unit-select-container').show();
            $('#o2-unit-input-container').hide('slow');
            cache.$submit.attr('disabled', true);
            var addressId = addresses[0].address_id;
            var endpoint = cache.$form.data('getmduunits-url');
            var mduScript = endpoint + '?addressId=' + addressId + '&callback=mduResponse';
            if (cache.$insertO2Script.children().length > 0) {
                cache.$insertO2Script.empty();
            }
            cache.$insertO2Script.append($('<script></script>').attr('src', mduScript));
        } else {
            cache.$submit.attr('disabled', false);
            $('#o2-unit-select-container').hide('slow');
            $('#o2-unit-input-container').show();
        }
    } else {
        cache.$latitude.val('');
        cache.$longitude.val('');
        cache.$serviceAddress.val('');
        cache.unit = '';
        $('#o2-unit-select-container').hide('slow');
        $('#o2-unit-input-container').show();
    }
});

$(document).on('mduEvent', function (e) {
    const { detail } = e;
    var baseAddr = $('#baseAddr').val();
    var geoAddrTyp = $('#geo_type').val();
    var addressUnits = detail.response.lstOfMDUUnits;
    var mduList = [];
    var mduAddressAliasList = [];
    var qfBlockedList = [];
    var o2UnitsOptions = $('#o2UnitsOptions');
    for (let i = 0; i < addressUnits.length; i++) {
        mduList[i] = addressUnits[i].fullSecUnitTxt;
        mduAddressAliasList[i] = addressUnits[i].addressAliasId;
        qfBlockedList[i] = addressUnits[i].qf_blocked;
    }
    if ($(o2UnitsOptions).children().length > 1) {
        $(o2UnitsOptions).empty();
    }
    let mdu = {};
    let mdus = [];
    let nounit = {};
    for (let j = 0; j < mduList.length; j++) {
        $(o2UnitsOptions).append($('<option>', {
            id: mduAddressAliasList[j],
            value: mduList[j],
            text: mduList[j]
        }));
        if (j === 0 && geoAddrTyp !== 'NOBASE') {
            nounit = {
                id: 'No-Unit',
                value: baseAddr,
                text: 'No-Unit',
                qf_blocked: 'No-Unit'
            };
            mdus.push(nounit);
        }
        mdu = { id: mduAddressAliasList[j], value: String(mduList[j]), text: String(mduList[j]), qf_blocked: qfBlockedList[j], latitude: addressUnits[j].latitude, longitude: addressUnits[j].longitude };
        mdus.push(mdu);
    }
    mdulistGlbl = mdus;
    $('#o2UnitsOptions').selectize()[0].selectize.destroy();
    var select = $('#o2UnitsOptions').selectize({
        options: mdus,
        createOnBlur: true,
        openOnFocus: true,
        highlight: true,
        persist: true,
        maxItems: 1,
        labelField: 'text',
        valueField: 'id',
        searchField: ['text'],
        placeholder: 'Please Select Unit',
        render: {
            option: function (item, escape) {
                return '<div class="option" data-qf-blocked="' + escape(item.qf_blocked) + '">' + escape(item.text) + '</div>';
            }
        },
        create: function (input) {
            return {
                id: 'customer_mdu_input',
                value: input,
                text: input
            };
        }
    });

    var selectize = select[0].selectize;
    $('#o2UnitsOptions-selectized').keydown(function () {
        $('#o2unitsKeyedIn').val(1);
    });
    selectize.open();
});

module.exports = {
    initEvents: function () {
        initO2Request();
        cache.$form.on('submit', renderUpddatedOutageMap);

        // o2 address is seleceted from autocomplete move focus to correct input or select
        $(document).on('click', '.addressSuggestion', function () {
            var o2UnitNumber = $('#o2UnitNumber');
            var o2UnitOptions = $('#o2UnitsOptions');
            $(o2UnitNumber).val(''); // clear value
            var isAddressMDU = $(this).find('input').data('mdu');
            if (isAddressMDU === 'FALSE') {
                if ($('#o2-unit-input-container').css('display') === 'block') {
                    $(o2UnitOptions).focus();
                }
            }
        });
        $(document).on('change', '#o2UnitNumber', function () {
            cache.unit = $('#o2UnitNumber').val();
        });
        // o2 address is seleceted from autocomplete move focus to Unit select
        $(document).on('change', '#o2UnitsOptions', function () {
            var o2UnitOptionsSelect = $('#o2UnitsOptions option:selected');
            var o2UnitOptionId = $(o2UnitOptionsSelect)[0].value;
            var o2unitsValue = $(o2UnitOptionsSelect)[0].innerHTML;
            var addressId = o2UnitOptionId;
            $('#addressId').val(addressId);
            $('#addressKey').val(addressId);
            cache.unit = o2unitsValue;

            if (addressId) {
                cache.$submit.attr('disabled', false);
            }
            if (addressId === 'No-Unit') {
                cache.$latitude.val(mdulistGlbl[1].latitude);
                cache.$longitude.val(mdulistGlbl[1].longitude);
            } else {
                for (var j = 0; j < mdulistGlbl.length; j++) {
                    if (addressId === mdulistGlbl[j].id) {
                        cache.$latitude.val(mdulistGlbl[j].latitude);
                        cache.$longitude.val(mdulistGlbl[j].longitude);
                        break;
                    }
                }
            }
        });

        $(document).on('click', '.js-outage-map', function (e) {
            renderUpddatedOutageMap(e);
        });
    }
};
